import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { styled, useTheme } from '@mui/material/styles'
import { LoadingButton } from '@mui/lab'
import Button from '@mui/material/Button'
import { Grid } from '@mui/material'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

export const GroupModal = ({
  title,
  open,
  activeStep,
  onPreviousClicked,
  onNextClicked,
  onCreateClicked,
  onCancelClicked,
  isCreating,
  submitButtonTitle,
  canCreate,
  labels = [],
  children
}) => {
  const StyledDialog = styled(Dialog)(() => [
    {
      '& .MuiPaper-root': {
        background: theme.palette.background.default
      }
    },
    isMobile
      ? {
          '& .MuiPaper-root': {
            width: '100%',
            margin: '0'
          }
        }
      : null
  ])

  const theme = useTheme()
  return (
    <StyledDialog open={open} fullWidth>
      <DialogTitle color={theme.palette.primary.main}>{title}</DialogTitle>

      <DialogContent>
        <Stepper activeStep={activeStep}>
          {labels.map((label) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
        {children}
      </DialogContent>

      <DialogActions>
        <Grid flexWrap="nowrap" container justifyContent="space-between">
          <Grid gap={1} item>
            <Button
              onClick={onPreviousClicked}
              disabled={activeStep === 0}
              sx={{ marginRight: '.5em' }}
              variant="outlined">
              Previous
            </Button>
            <Button
              onClick={onNextClicked}
              disabled={activeStep === labels.length - 1}
              color="secondary"
              variant="contained">
              Next
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={onCancelClicked} sx={{ marginRight: '.5em' }} variant="outlined">
              Cancel
            </Button>
            <LoadingButton
              onClick={onCreateClicked}
              disabled={isCreating || !canCreate}
              loading={isCreating}
              color="secondary"
              variant="contained">
              {submitButtonTitle ? submitButtonTitle : isCreating ? 'Creating' : 'Create'}
            </LoadingButton>
          </Grid>
        </Grid>
      </DialogActions>
    </StyledDialog>
  )
}
